import { render, staticRenderFns } from "./PurchasePlan.vue?vue&type=template&id=6f84d50c&scoped=true"
import script from "./PurchasePlan.vue?vue&type=script&lang=js"
export * from "./PurchasePlan.vue?vue&type=script&lang=js"
import style0 from "./PurchasePlan.vue?vue&type=style&index=0&id=6f84d50c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f84d50c",
  null
  
)

export default component.exports